import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast } from 'components/Toast';
import { STRINGS } from 'config';
import { SnomedEntry } from 'model/toolbar/snomed';
import React from 'react';
import request, { Response } from 'superagent';

const { HOST } = STRINGS.SUMMARISER;

const {
  SNOMED: {
    AI_SNOMED_REQUEST_PENDING,
    AI_SNOMED_REQUEST_SUCCESS,
    AI_SNOMED_REQUEST_FAILED,
    AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_PENDING,
    AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_SUCCESS,
    AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_FAILED,
  },
} = STRINGS.REDUCERS;

type AiSnomedPayload = {
  summary: string;
  consultationId: string;
};

type AiSnomedCountPayload = {
  enabled: string[];
  ignored: string[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AiSnomedResponse = any;

type AiSnomedAction =
  | { type: typeof AI_SNOMED_REQUEST_PENDING }
  | { type: typeof AI_SNOMED_REQUEST_SUCCESS; payload: AiSnomedResponse }
  | { type: typeof AI_SNOMED_REQUEST_FAILED; error: string };

export const fetchAiSnomedCodes = async (
  dispatch: React.Dispatch<AiSnomedAction>,
  payload: AiSnomedPayload,
  selectedPracticeId: string,
): Promise<Response | void> => {
  try {
    dispatch({ type: AI_SNOMED_REQUEST_PENDING });
    const response: Response = await request
      .post(`${HOST}/generate/snomed?practiceId=${selectedPracticeId}`)
      .set('Content-Type', 'application/json')
      .send(payload)
      .withCredentials();

    const aiSnomedCodes: SnomedEntry[] = response.body?.codes?.length
      ? response.body.codes.map((item: SnomedEntry) => ({
          code: item.code,
          info: item.description,
          unit: '',
          value: '',
        }))
      : [];
    dispatch({
      type: AI_SNOMED_REQUEST_SUCCESS,
      payload: aiSnomedCodes,
    });

    return response;
  } catch (error: unknown) {
    let message = 'Something went wrong';
    if (error && typeof error === 'object' && 'message' in error) {
      message = (error as Error).message;
    }
    toast.error(
      React.createElement(ErrorToast, {
        message: 'Sorry, the AI snomed code generation had an error.',
      }),
      {
        autoClose: 12000,
        pauseOnHover: true,
        hideProgressBar: false,
        closeOnClick: true,
        icon: false,
      },
    );
    return dispatch({
      type: AI_SNOMED_REQUEST_FAILED,
      error: message,
    });
  }
};

export const updateAiSnomedCodeCounts = async (
  dispatch: React.Dispatch<AiSnomedAction>,
  payload: AiSnomedCountPayload,
  selectedPracticeId: string,
): Promise<Response | void> => {
  try {
    dispatch({ type: AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_PENDING });
    return await request
      .post(`${HOST}/ai-snomed-code-count?practiceId=${selectedPracticeId}`)
      .set('Content-Type', 'application/json')
      .send(payload)
      .withCredentials()
      .then((response: Response) => {
        dispatch({ type: AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_SUCCESS });
        return response;
      });
  } catch (error: unknown) {
    return dispatch({ type: AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_FAILED });
  }
};
